// ==============================|| CUSTOM FUNCTION - COLOR SHADOWS ||============================== //
const getShadow = (theme, shadow) => {
    switch (shadow) {
        case 'soft':
            return theme.customShadows.soft;
        case 'hard':
            return theme.customShadows.hard;
        default:
            return theme.customShadows.soft;
    }
};
export default getShadow;
